<div class="px-6 py-8 bg-white rounded-2xl w-full shadow-card overflow-hidden">
  <ng-content></ng-content>
</div>
